module.exports = __webpack_public_path__ + "static/media/teespring.9227ce89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client-logos/teespring.png
// module id = 276
// module chunks = 0